// src/pages/Home.jsx
import React from 'react';
import MainLayout from '../components/Layouts/MainLayout';
import InnerBanner from '../components/PagesComponents/InnerBanner';
import ResetPasswordForm from '../components/Auth/ResetPasswordForm';

const RestPassword = () => {
  return(
  <MainLayout>
    <InnerBanner pageKey="resetPassword" />
     <ResetPasswordForm/>
  </MainLayout>
);
}

export default RestPassword;
